var map = {
	"./bosch.jpg": 399,
	"./broodthaers.jpg": 400,
	"./certificate-of-authenticity.jpg": 401,
	"./leonardo-da-vinci.jpg": 402,
	"./pilar-animal-selfie.jpg": 403,
	"./postinternet-definition.jpg": 404,
	"./salvador-dali.jpg": 405,
	"./vr-museum.jpg": 406
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 417;



/*****************
 ** WEBPACK FOOTER
 ** ./components/Modal/images/large ^\.\/.*$
 ** module id = 417
 ** module chunks = 0
 **/